import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common'
import { ApiService } from '../../../services/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-financialstatus-report',
  templateUrl: './financialstatus-report.component.html',
  styleUrls: ['./financialstatus-report.component.css']
})
export class FinancialstatusReportComponent implements OnInit {

  @ViewChild('closeModal') private closeModal!: ElementRef;
  @ViewChild('close_acc') private close_acc!: ElementRef;


  admin_data: any;
  fiscal_year: any;
  data_all: any;
  date_all = [] as any;
  year_all = [] as any;
  date_select: any;
  year_select: any;
  data_select = {
    id: '',
    fiscal_year: '',
    date: '',
    account: {
      acc_fixed: [] as any, //ฝากประจำ
      acc_savings: [] as any, //ฝากออมทรัพย์
      acc_current: [] as any, //ฝากกระแสรายวัน
      acc_deposits: [] as any, //ฝากคลัง
    },
    status: '',
    user_id: ''
  }
  data_select_sum: number = 0;
  acc_type = ['บัญชีเงินฝากประจำ', 'บัญชีเงินฝากออมทรัพย์', 'บัญชีเงินฝากกระแสรายวัน', 'เงินฝากกระทรวงการคลัง'];
  acc_new = {} as any;
  acc_edit = {
    id: '',
    fiscal_year: '',
    date: '',
    date_th: '',
    account: {
      acc_fixed: [] as any, //ฝากประจำ
      acc_savings: [] as any, //ฝากออมทรัพย์
      acc_current: [] as any, //ฝากกระแสรายวัน
      acc_deposits: [] as any, //ฝากคลัง
    },
    status: '',
    user_id: ''
  }

  acc_edit_account: any;
  //ตัวแปรเก็บค่าบัญชีแต่ละประเภท
  acc_fixed = [] as any; //ฝากประจำ
  acc_savings = [] as any; //ฝากออมทรัพย์
  acc_current = [] as any; //ฝากกระแสรายวัน
  acc_deposits = [] as any; //ฝากคลัง
  //ตัวแปรเพิ่มบัญชีใหม่
  data_type: any;
  data_accnum: any;
  data_amount: any;

  accnum_status: boolean = false;
  list_accnum: any
  form_accnum!: FormGroup;
  types = ['บัญชีเงินฝากประจำ', 'บัญชีเงินฝากออมทรัพย์', 'บัญชีเงินฝากกระแสรายวัน']
  accnum_data = {
    fix: [] as any,
    save: [] as any,
    current: [] as any
  };
  form_editaccnum!: {
    id: number,
    type: '',
    accnum: '',
    accname: '',
    user_id: number,
    status: ''
  };
  editAccnum_status: boolean = false;
  enableEditIndex!: null;

  constructor(
    public services: ApiService,
    public formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    document.getElementById('financialstatus')!.classList.toggle("active");

    this.admin_data = localStorage.getItem("admin_data");
    this.admin_data = JSON.parse(this.admin_data);
    this.fiscal_year = this.services.fiscal_year
    var month = new DatePipe('en-US').transform(new Date(), 'MM')
    var year = new DatePipe('en-US').transform(new Date(), 'yyyy')
    var date = new Date(parseInt(year!), parseInt(month!), 0);
    this.onclick();
    this.getDataAll();
    this.acc_new = {
      fiscal_year: Number(year) + 543,
      date: new DatePipe('en-US').transform(new Date(date), 'yyyy-MM-dd'),
      account: {} as any,
      sum: 0,
      user_id: this.admin_data.id,
      status: ''
    }
    this.form_accnum = this.formBuilder.group({
      type: '',
      accnum: '',
      accname: '',
      user_id: parseInt(this.admin_data.id)
    });
    this.get_accnum();
  }

  ngOnDestroy() {
    document.getElementById('financialstatus')!.classList.remove("active");
  }

  getDataAll() {
    var dataAll = [] as any;
    this.services.get('m_financialstatus').then((res: any) => {
      res.forEach((data: any) => {
        if (data.status == 'Enable') {
          this.year_all.push(data.fiscal_year)  //อาเรย์เก็บปีของข้อมูลทั้งหมด
          data.date_th = this.dateThaiFormat(data.date)
          dataAll.push(data); //เก็บข้อมูลที่ status = Enable
        }
      });
      dataAll = dataAll.sort((a: any, b: any) => (a.date > b.date) ? -1 : ((b.date > a.date) ? 1 : 0))
      this.getData(dataAll);
    });

  }
  getData(data: any) {
    this.date_all = [] //อาเรย์เปล่าเก็บวันที่ของข้อมูลทั้งหมด
    this.data_all = data; //ตัวแปลเก็บข้อมูลสถานะทางการเงินทั้งหมด
    this.date_select = this.date_all[0]; //ตั้งวันที่เริ่มต้นของข้อมูลเป็นวันที่ล่าสุดของข้อมูล
    this.year_all = [...new Set(this.year_all)].sort();
    this.year_all = this.year_all.reverse();
    this.year_select = this.year_all[0];
    this.data_all.forEach((res: any) => {
      if (res.fiscal_year == this.year_select) {
        this.date_all.push(res.date_th)
      }
    })
    this.date_select = this.date_all[0];
    this.selectDate(); //เรียกข้อมูลไปแแสดง
  }
  //เลือกข้อมูล
  selectYear() {
    this.date_all = []
    this.data_all.forEach((res: any) => {
      if ((res.fiscal_year) == this.year_select) {
        this.date_all.push(res.date_th)
      }
    })
    this.date_select = this.date_all[0]
    this.selectDate(); //เรียกข้อมูลไปแแสดง
  }
  selectDate() {
    this.data_select_sum = 0;
    this.data_all.forEach((data: any) => {
      if (data.date_th == this.date_select) {
        //ข้อมูลที่แสดง
        this.data_select.id = data.id;
        this.data_select.fiscal_year = data.fiscal_year;
        this.data_select.date = data.date;
        this.data_select.account.acc_current = JSON.parse(data.account).acc_current;
        this.data_select.account.acc_fixed = JSON.parse(data.account).acc_fixed;
        this.data_select.account.acc_savings = JSON.parse(data.account).acc_savings;
        this.data_select.account.acc_deposits = JSON.parse(data.account).acc_deposits;
        this.data_select.user_id = data.user_id;
        this.data_select.status = data.status;
        //ข้อมูลที่เอาไว้ไปแก้ไข
        this.acc_edit.id = data.id;
        this.acc_edit.fiscal_year = data.fiscal_year
        this.acc_edit.date = data.date;
        this.acc_edit.date_th = this.dateThaiFormat(data.date);
        this.acc_edit.account.acc_current = JSON.parse(data.account).acc_current;
        this.acc_edit.account.acc_fixed = JSON.parse(data.account).acc_fixed;
        this.acc_edit.account.acc_savings = JSON.parse(data.account).acc_savings;
        this.acc_edit.account.acc_deposits = JSON.parse(data.account).acc_deposits;
        this.acc_edit.user_id = this.admin_data.id;
        this.acc_edit.status = data.status;
      }
    });
    //sum
    this.data_select.account.acc_current.forEach((data: any) => {
      this.data_select_sum += data.acc_amount
    });
    this.data_select.account.acc_fixed.forEach((data: any) => {
      this.data_select_sum += data.acc_amount
    });
    this.data_select.account.acc_savings.forEach((data: any) => {
      this.data_select_sum += data.acc_amount
    });
    this.data_select.account.acc_deposits.forEach((data: any) => {
      this.data_select_sum += data.acc_amount
    });
  }
  //set disable 
  onclick() {
    (document.getElementById('saveBtn') as HTMLInputElement).disabled = true;
    document.getElementById('acc_table')!.style.display = "none";
    document.getElementById('edit_table')!.style.display = "none";
  }
  //เพิ่มรายการบัญชี
  onClickAdd(formAcc: any) {
    this.data_amount = parseFloat(this.data_amount);
    document.getElementById('edit_table')!.style.display = "flex";
    document.getElementById('acc_table')!.style.display = 'flex';
    if (this.acc_new.date != '' && this.acc_new.fiscal_year != '') {
      (document.getElementById('saveBtn') as HTMLInputElement).disabled = false;
    }
    switch (this.data_type) {
      case 'บัญชีเงินฝากประจำ': {
        this.acc_fixed.push({
          acc_type: this.data_type,
          acc_num: this.data_accnum,
          acc_amount: this.data_amount
        })
        break;
      }
      case 'บัญชีเงินฝากออมทรัพย์': {
        this.acc_savings.push({
          acc_type: this.data_type,
          acc_num: this.data_accnum,
          acc_amount: this.data_amount
        })
        break;
      }
      case 'บัญชีเงินฝากกระแสรายวัน': {
        this.acc_current.push({
          acc_type: this.data_type,
          acc_num: this.data_accnum,
          acc_amount: this.data_amount
        })
        break;
      }
      case 'เงินฝากกระทรวงการคลัง': {
        this.acc_deposits.push({
          acc_type: this.data_type,
          acc_num: this.data_accnum,
          acc_amount: this.data_amount
        })
        break;
      }
      default: {
        // console.log('selected not found');
        break;
      }
    }
    formAcc.reset();
  }
  //ลบรายการบัญชีที่เพิ่ม
  onClickDel(type: any, i: any) {
    switch (type) {
      case 'บัญชีเงินฝากประจำ': {
        this.acc_fixed.splice(i, 1);
        break;
      }
      case 'บัญชีเงินฝากออมทรัพย์': {
        this.acc_savings.splice(i, 1);
        break;
      }
      case 'บัญชีเงินฝากกระแสรายวัน': {
        this.acc_current.splice(i, 1);
        break;
      }
      case 'เงินฝากกระทรวงการคลัง': {
        this.acc_deposits.splice(i, 1);
        break;
      }
      default: {
        // console.log('selected not found');
        break;
      }
    }
    //check disabled btn when value null
    if (this.acc_fixed.length == 0 && this.acc_savings.length == 0 && this.acc_current.length == 0 && this.acc_deposits.length == 0) {
      document.getElementById('acc_table')!.style.display = "none";
      document.getElementById('edit_table')!.style.display = "none";

      (document.getElementById('saveBtn') as HTMLInputElement).disabled = true;
      (document.getElementById('editBtn') as HTMLInputElement).disabled = true;
    }
  }
  //เพิ่มรายงานสถานะทางการเงิน
  onClickSave(form: any) {
    form.value.sum = 0
    form.value.user_id = this.admin_data.id;
    form.value.status = "Enable";
    this.acc_new.account = {
      acc_fixed: this.acc_fixed,
      acc_savings: this.acc_savings,
      acc_current: this.acc_current,
      acc_deposits: this.acc_deposits
    };

    form.value.account = JSON.stringify(this.acc_new.account);
    this.services.create('m_financialstatus', form.value).then((res: any) => {
      var month = new DatePipe('en-US').transform(new Date(), 'MM')
      var year = new DatePipe('en-US').transform(new Date(), 'yyyy')
      var date = new Date(parseInt(year!), parseInt(month!), 0);
      this.acc_new = {
        fiscal_year: Number(year) + 543,
        date: new DatePipe('en-US').transform(new Date(date), 'yyyy-MM-dd'),
        account: {} as any,
        sum: 0,
        user_id: this.admin_data.id,
        status: ''
      }

      this.acc_new.account = {}
      this.acc_new.sum = 0;
      this.acc_fixed = [];
      this.acc_savings = [];
      this.acc_current = [];
      this.acc_deposits = [];
      this.getDataAll();
      Swal.fire({
        title: 'เพิ่มรายงานสำเร็จ',
        icon: 'success',
        confirmButtonText: `ตกลง`,
      })
    });
  }
  //บันทึกการแก้ไขรายงานสถานะทางการเงิน
  onClickUpdate() {
    this.acc_fixed.forEach((data: any) => {
      this.acc_edit.account.acc_fixed.push(data);
    });
    this.acc_savings.forEach((data: any) => {
      this.acc_edit.account.acc_savings.push(data)
    });
    this.acc_current.forEach((data: any) => {
      this.acc_edit.account.acc_current.push(data)
    });
    this.acc_deposits.forEach((data: any) => {
      this.acc_edit.account.acc_deposits.push(data)
    });
    const datas = {
      id: parseInt(this.acc_edit.id),
      fiscal_year: this.acc_edit.fiscal_year,
      date: this.acc_edit.date,
      account: JSON.stringify(this.acc_edit.account),
      status: this.acc_edit.status,
      user_id: this.acc_edit.user_id
    };

    Swal.fire({
      title: 'ยืนยันการแก้ไข',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: `ไม่ใช่`,
      showDenyButton: true
    }).then((res) => {
      if (res.isConfirmed) {
        this.closeModal.nativeElement.click();
        this.services.update('m_financialstatus', datas.id, datas).then((res: any) => {
          this.acc_fixed = [];
          this.acc_savings = [];
          this.acc_current = [];
          this.acc_deposits = [];
          this.getDataAll();
          Swal.fire({
            title: 'แก้ไขรายงานสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`,
          })
        });
      }
    })


  }
  //ลบบัญชีทีละรายการ
  onClickDelList(data: any, index: any) {
    data.splice(index, 1)
  }
  //ลบรายงานสถานะทางการเงิน
  onClickDelete(data: any) {
    data.status = 'Disable';
    const datas = {
      id: parseInt(data.id),
      date: data.date,
      account: JSON.stringify(data.account),
      status: data.status,
      user_id: parseInt(data.user_id)
    };
    Swal.fire({
      title: 'ยืนยันการลบ',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: `ไม่ใช่`,
      showDenyButton: true
    }).then((res) => {
      if (res.isConfirmed) {
        this.closeModal.nativeElement.click();
        this.services.update('m_financialstatus', datas.id, datas).then((res: any) => {
          Swal.fire({
            title: 'ลบรายงานสถานะทางการเงิน ของวันที่ ' + data.date,
            icon: 'success',
            confirmButtonText: `ตกลง`
          }).then((res) => {
            this.getDataAll();
          })
        })
      }
    })
  }
  //ยกเลิกการแก้ไข
  onClickCancle() {
    this.getDataAll();
  }

  clearForm() {
    this.data_type = ''
    this.data_accnum = ''
    this.data_amount = ''
  }
  select_account() {
    const lists = [] as any
    switch (this.data_type) {
      case 'บัญชีเงินฝากประจำ': {
        this.accnum_data.fix.forEach((e: any) => {
          lists.push(e.accnum)
        });
        break;
      }
      case 'บัญชีเงินฝากออมทรัพย์': {
        this.accnum_data.save.forEach((e: any) => {
          lists.push(e.accnum)
        });
        break;
      }
      case 'บัญชีเงินฝากกระแสรายวัน': {
        this.accnum_data.current.forEach((e: any) => {
          lists.push(e.accnum)
        });
        break;
      }
      default: {
        lists.push('')
        break;
      }
    }
    this.list_accnum = lists
    this.data_accnum = (this.list_accnum[0]).toString()
  }
  async get_accnum() {
    await this.services.get('m_accnum').then((res: any) => {
      const data_all = res.filter((data: any) => {
        return data.status.toLowerCase().match('enable')
      })
      this.accnum_data.fix = data_all.filter((data: any) => {
        return data.type.match('บัญชีเงินฝากประจำ')
      })
      this.accnum_data.save = data_all.filter((data: any) => {
        return data.type.match('บัญชีเงินฝากออมทรัพย์')
      })
      this.accnum_data.current = data_all.filter((data: any) => {
        return data.type.match('บัญชีเงินฝากกระแสรายวัน')
      })
    })
  }
  save_accnum() {
    Swal.fire({
      title: 'ยืนยันการเพิ่มเลขที่บัญชี',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: `ไม่ใช่`,
      showDenyButton: true
    }).then((res) => {
      if (res.isConfirmed) {
        this.services.create('m_accnum', this.form_accnum.value).then((res: any) => {
          Swal.fire({
            title: 'บันทึกสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`
          }).then((res) => {
            this.get_accnum();
            this.close_accnum();
          })
        })
      } else {
        this.close_accnum();
      }
    })

  }
  close_accnum() {
    this.form_accnum = this.formBuilder.group({
      type: '',
      accnum: '',
      accname: '',
      user_id: parseInt(this.admin_data.id)
    });
    this.accnum_status = false
  }
  del_accnum(data: any) {
    const data_del = data
    data_del.status = "Disable"
    Swal.fire({
      title: 'ยืนยันการลบเลขที่บัญชี',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: `ไม่ใช่`,
      showDenyButton: true
    }).then((res) => {
      if (res.isConfirmed) {
        this.services.update('m_accnum', Number(data.id), data_del).then((res: any) => {
          Swal.fire({
            title: 'ลบสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`
          }).then((res) => {
            this.get_accnum();
          })
        })
      }
    })

  }
  update_accnum(data: any, i: any) {
    this.editAccnum_status = true;
    this.enableEditIndex = i;

    this.form_editaccnum = {
      id: Number(data.id),
      type: data.type,
      accnum: data.accnum,
      accname: data.accname,
      user_id: Number(this.admin_data.id),
      status: data.status
    };



  }
  updateE_accnum() {
    Swal.fire({
      title: 'ยืนยันการแก้ไขเลขที่บัญชี',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: `ไม่ใช่`,
      showDenyButton: true
    }).then((res) => {
      if (res.isConfirmed) {
        this.services.update('m_accnum', Number(this.form_editaccnum.id), this.form_editaccnum).then((res: any) => {
          Swal.fire({
            title: 'แก้ไขสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`
          }).then((res) => {
            this.closeE_accnum()
            this.get_accnum();
          })
        })
      }
    })
  }
  closeE_accnum() {
    this.editAccnum_status = false;
    this.enableEditIndex = null;
  }

  numberWithCommas(x: any) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  dateThaiFormat(date: any) {
    return date = new Date(date).toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
}
